<li *ngFor="let category of categories$ | async" [class.expanded]="toggle.active">
	<div appToggle #toggle="appToggle">{{category.name}}</div>
	<div class="links">
		<button *ngFor="let step of category.items" 
				[workflowStep]="step.name" 
				[appWorkflowItemStatus]="step.id" 
				[routerLink]="step | workflowStepUrl" 
				routerLinkActive="active"
				[queryParams]="{continue:true}">
		</button>
	</div>
</li>